import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { api } from "../lib/api";
import { CheckCircle } from "@phosphor-icons/react";
import { Button } from "../components/ui/button";

export default function PaymentSuccess() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const provider = params.get("provider") || "stripe";
  const [status, setStatus] = useState(provider === "razorpay" ? "paid" : "checking");

  useEffect(() => {
    if (!sessionId) { navigate("/storage"); return; }
    if (provider === "razorpay") { setStatus("paid"); return; }
    let attempts = 0;
    const iv = setInterval(async () => {
      attempts++;
      try {
        const r = await api.get(`/payments/status/${sessionId}`);
        if (r.data.payment_status === "paid") {
          clearInterval(iv);
          setStatus("paid");
        } else if (r.data.payment_status === "failed" || attempts > 20) {
          clearInterval(iv);
          setStatus("failed");
        }
      } catch {
        attempts += 1;
        if (attempts > 20) { clearInterval(iv); setStatus("failed"); }
      }
    }, 2000);
    return () => clearInterval(iv);
  }, [sessionId, provider, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-6" data-testid="payment-success-page">
      <div className="max-w-md text-center">
        {status === "paid" ? (
          <>
            <CheckCircle size={64} weight="duotone" className="text-primary mx-auto mb-6" />
            <h1 className="font-serif text-4xl mb-3">You're all set.</h1>
            <p className="text-muted-foreground mb-8">Extra storage added to your account.</p>
            <Button
              data-testid="back-to-dashboard-btn"
              onClick={() => navigate("/dashboard")}
              className="rounded-full bg-primary text-primary-foreground"
            >
              Back to diary
            </Button>
          </>
        ) : status === "checking" ? (
          <p className="font-serif text-3xl italic text-primary">Confirming your payment…</p>
        ) : (
          <>
            <h1 className="font-serif text-4xl mb-3">Something went wrong.</h1>
            <p className="text-muted-foreground mb-8">We couldn't confirm the payment.</p>
            <Button
              data-testid="try-again-btn"
              onClick={() => navigate("/storage")}
              className="rounded-full bg-primary text-primary-foreground"
            >
              Try again
            </Button>
          </>
        )}
      </div>
    </div>
  );
}
